import { getDeepProperty as getDeepObjectProperty } from "@/utils/object";
import * as AssetAPI from "@/services/api/assets";

type Dictionary<T> = { [k:string]:T }

type LabelFactory = (node:any, parameters:any) => Promise<string>

const factories:Dictionary<LabelFactory> = {};

factories["CognitiveTest"] = async (node, parameters) => {
	if(node.name){ return node.name; }
	const useAsset = getDeepObjectProperty(parameters, "useAsset", false);
	const assetId = getDeepObjectProperty(parameters, "asset.ref.asset", null);
	if(useAsset && assetId){
		try {
			const asset = await AssetAPI.getAsset(assetId);
			return `info;${asset.name}`;
		}
		catch(err){}
		return "dark;Cognitive Test";
	}
	return getDeepObjectProperty(parameters, "testType", "warning;<unconfigured>");
}

factories["Form"] = async (node, parameters) => {
	if(node.name){ return node.name; }
	const assetId = getDeepObjectProperty(parameters, "asset.ref.asset", null);
	if(!assetId){ "dark;Form"; }

	try {
		const asset = await AssetAPI.getAsset(assetId);
		return `info;${asset.name}`;
	}
	catch{}
	return "dark;Form";
}

factories["Select"] = async (parameters) => {
	return "";
}

factories["Scene"] = async (node, parameters) => {
	return "dark;Scene";
}

factories["Gallery"] = async (node, parameters) => {
	if(node.name){ return node.name; }
	const assetId = getDeepObjectProperty(parameters, "asset.ref.asset", null);
	if(!assetId){ "dark;Gallery"; }

	try {
		const asset = await AssetAPI.getAsset(assetId);
		return `info;${asset.name}`;
	}
	catch{}
	// return "danger;<missing ref>";	
	return "dark;Gallery";
}

export const computeNodeLabel = async (node:any) => {
	const factory = factories[node.type];
	if(!factory){ return ""; }
	return await factory(node, node.parameters);
}